<div class="chart-container">
  <h3 class="chart-title">Compressive Strength - Water/Cement Ratio</h3>
  <div class="chart-wrapper">
    <canvas
      baseChart
      [data]="lineChartData"
      [options]="lineChartOptions"
      [type]="'line'">
    </canvas>
  </div>
</div>
